/*
    I parse the query string and return an object representing the parameters
    provided.  Params with a single value will be returned as a string, while
    params with multiple values will be returned as a comma delimited list. The
    `merge` param can be used to override the merge/combing behavior. All keys
    and values will be URL-decoded.
*/
export const parse = (
    queryString = window.location.search,
    merge = (agg, it) => agg + "," + it,
) => {
    const params = {};
    if (queryString) {
        if (queryString.indexOf("?") === 0) {
            queryString = queryString.substr(1);
        }
        for (const pair of queryString.split("&")) {
            const parts = pair.split("=");
            const name = decodeURIComponent(parts.shift());
            let value = parts.join("=");
            value = decodeURIComponent(value != null ? value : "");
            if (params[name] != null) {
                params[name] = merge(params[name], value);
            } else {
                params[name] = value;
            }
        }
    }
    return params;
};

/*
    I take a set of key-value pairs and return a query string representing the
    same data.  Values will be implicitly stringified, so complex values will
    need to be pre-serialized.  All keys and values will be URL-encoded.
*/
export const serialize = params => {
    const s = [];
    for (const n in params) {
        const v = params[n];
        s.push(encodeURIComponent(n) + "=" + encodeURIComponent(v));
    }
    return s.join("&");
};

export default {
    parse,
    serialize,
};



// WEBPACK FOOTER //
// ./app/query_string.js